export default "__VITE_ASSET__prvsjNPv__"